
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'AuthUserNote',
  setup() {
    const { locale } = useI18n()
    const fluxTermsUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_TERMS_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_TERMS_PAGE_PATH}`
    })
    const fluxPrivacyPolicyUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH}`
    })
    return {
      fluxTermsUrl,
      fluxPrivacyPolicyUrl,
      ...useI18n(),
    }
  },
})
